<h3>Interview Ready @if (count > 0) {<span>{{count}}</span>}</h3>
@if (!isLoading) {
    <div class="incomplete">
        @if (!noData) {
            <table class="table table-striped table-fixed">
                <tbody>
                    @for (a of applicants; track a) {
                        <tr class="applicant" (click)="openApplicant(a)">
                            <td>
                                <app-round-image class="profile-image" [url]="a.profile" [useDefaultMissingImage]="true" [width]="30"
                                    [height]="30"></app-round-image>
                            </td>
                            <td class="new-applicant">
                                @if (a.isNewToUser) {
                                    <i class="fa-solid fa-circle-plus"></i>
                                }
                            </td>
                            <td>{{a.name}}</td>
                            <td class="state">{{a.userState}}</td>
                        </tr>
                    }
                </tbody>
            </table>
        }
        @if (noData) {
            <div>
                <p>No applicants ready for an interview.</p>
            </div>
        }
    </div>
} @else {
    <div class="loading">
        <div class="load_container">
            <img src="img/stopwatch.svg" class="bl">
        </div>
    </div>
}